const FlashSubTextStyle = `
    background: #eee;
    border-radius: 5px;
    color: #aaa;
    margin: 10px 0;
    padding: 10px;
`;

export default FlashSubTextStyle;
